export const API_GET_ALL_COMPANY = '/admin/empresas/';
export const API_GET_SEARCH_COMPANY = '/admin/empresas/buscar/';
export const API_GET_SETTINGS_COMPANY = '/admin/configuraciones/';
export const API_GET_ALL_SETTINGS = '/admin/configuraciones/listar/'
export const API_PUT_SETTINGS = '/admin/configuraciones/actualizar/configuracion/empresa/'
export const API_POST_SETTINGS = '/admin/configuraciones/registro/configuracion/empresa/'
export const API_DELETE_SETTINGS = '/admin/configuraciones/eliminar/configuracion/empresa/'